import config from '@/config'
import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import premiums from './data/premiums.js'
import presets from './data/presets.js'
import getters from './getters'
import mutations from './mutations'

import { ALL_IN_ONE_CHAT_PAGE_ID, ALL_IN_ONE_CHAT_THEME_LIST } from '@/constants/all-in-one-chat.js'
import { LIVE_PAGE_ID } from '@/constants/live.js'
import { NTN_PAGE } from '@/constants/ntn.js'
import { ADS_SIMULATOR_PAGE } from '@/constants/adsSimulator.js'
import { NVBB_DROPPOINT_LOCATION_OPTIONS } from '@/constants/nvbb.js'
import { SHOP_THEME_LIST } from '@/constants/shop.js'
import { BEACON_PAGE_LIST } from '@/constants/beacon.js'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    socialChannelOptions: [
      {
        value: 'fb',
        fullValue: 'facebook',
        fullValueForUse: 'facebook',
        text: 'Facebook',
        icon: 'fas fa-brands fa-facebook'
      },
      // {
      //   value: 'ig',
      //   fullValue: 'instagram',
      //   fullValueForUse: 'instagram',
      //   text: 'Instagram',
      //   icon: 'fab fa-instagram'
      // },
      // {
      //   value: 'line',
      //   fullValue: 'line',
      //   fullValueForUse: 'line',
      //   text: 'Line',
      //   icon: 'fab fa-line'
      // },
      {
        value: 'webchat',
        fullValue: 'webchat',
        fullValueForUse: 'webchat',
        text: 'Web Chat',
        icon: 'fas fa-globe'
      },
      {
        value: 'app',
        fullValue: 'app',
        fullValueForUse: 'app',
        text: 'App Chat',
        icon: 'fas fa-mobile-alt'
      },
      {
        value: 'ms_team',
        fullValue: 'microsoft teams',
        fullValueForUse: 'ms_team',
        text: 'Microsoft Teams',
        icon: 'fas fa-brands fa-windows'
      },
      {
        value: 'x',
        fullValue: 'x',
        fullValueForUse: 'x',
        text: 'X',
        icon: 'fas fa-brands fa-x'
      },
      {
        value: 'pantip',
        fullValue: 'pantip',
        fullValueForUse: 'pantip',
        text: 'Pantip',
        icon: 'fas fa-brands fa-pantip'
      }
    ],
    checkIn: false,
    edittingIntent: [],
    botStatus: false,
    loading: false,
    newcomer: Vue.localStorage.get('newcomer') === 'true',
    facebook_name: Vue.localStorage.get('facebook_name')
      ? Vue.localStorage.get('facebook_name')
      : Vue.localStorage.get('userid'),
    isLoggedIn: !!Vue.localStorage.get('token'),
    isFacebook: Vue.localStorage.get('FB') === 'true',
    isSelectedBot: !!Vue.localStorage.get('selectedBot'),
    selectedBot:
      Vue.localStorage.get('selectedBot') && Vue.localStorage.get('selectedBot') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('selectedBot'))
        : [],
    userid: Vue.localStorage.get('userid'),
    userEmail: Vue.localStorage.get('userEmail'),
    botlist:
      Vue.localStorage.get('botlist') && Vue.localStorage.get('botlist') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('botlist'))
        : [],
    pagelist:
      Vue.localStorage.get('pagelist') && Vue.localStorage.get('pagelist') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('pagelist'))
        : [],
    accessToken: Vue.localStorage.get('token'),
    fbAccessToken: Vue.localStorage.get('fbtoken'),
    openSidebar: true,
    paypalTrackingId: Vue.localStorage.get('paypalTrackingId'),
    setting: undefined,
    welcomeMessage: undefined,
    showModalWelcome: Vue.localStorage.get('showModalWelcome'),
    theme: config.theme,
    chatbot: {
      intentGroup: undefined
    },
    loginChannel: ['facebook', 'account', 'chat2pay'].includes(Vue.localStorage.get('loginChannel'))
      ? Vue.localStorage.get('loginChannel')
      : 'facebook',
    fbScope: Vue.localStorage.get('fbScope'),
    tutoriallist: [],
    alert:
      Vue.localStorage.get('alerts') && Vue.localStorage.get('alerts') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('alerts'))
        : [],
    partner_code: Vue.localStorage.get('partner_code')
      ? Vue.localStorage.get('partner_code')
      : undefined,
    pageBU: ['114743896611281', '132880665271'],
    specialpage: [
      '274108073649',
      '619202881423565',
      '2261615673888062',
      '1231805606976542',
      '1493632560856869',
      '2105726733070683',
      '391365474996527',
      '282419538600861',
      '229446640739626',
      '229777340553912',
      '1422119811377985',
      '1441887002726565',
      '367229174088451',
      '2244102365841101'
    ],
    pageRussianRoulette: ['101900391252252', '582769212229333'],
    lineimagemapbypageid: [
      '102074341651763',
      '109547317606650',
      '394274810994296',
      '355634702145095',
      '105479814959388',
      '105077088474056', //Foodguru test
      '1192315994209757', //Foodguru
      '100339565610749',
      '102370245472711', // Test Lamy
      '2037301563028410', //Lamy
      '106858277640083',
      '102126962268028', //Test Prudential
      '110807598418528'
    ],
    livepage: LIVE_PAGE_ID,
    linenotifylist: [],
    ecommerce: {
      products: [],
      loadingProduct: true,
      categories: [],
      loadingCategory: true,
      charges: {},
      loadingCharges: true
    },
    loadingUserStatus: true,
    userStatus: [],
    loadingSetting: true,
    groupConversation: [],
    loadingGroupConversation: true,
    linePushMessageCount: null,
    loadingLinePushMessageCount: true,
    uuAreaName: [
      'ประปาบางปะกง',
      'ประปาฉะเชิงเทรา',
      'ประปาบ่อวิน',
      'ประปาหนองขาม',
      'ประปาสัตหีบ',
      'ประปาระยอง',
      'ประปานครสวรรค์',
      'ประปาหัวรอ',
      'ประปาเทศบาลพระนครศรีอยุธยา',
      'นอกพื้นที่บริการ'
    ],
    livechatPageList: ALL_IN_ONE_CHAT_THEME_LIST,
    showSession: ['111895158162143'],
    pageListSingGaling: ['100856422547014', '352145869189954'],
    pageListCityfresh: ['105432182130709', '462339517184685'],
    livechatPageIdList: ALL_IN_ONE_CHAT_PAGE_ID,
    beaconPageIdList: BEACON_PAGE_LIST,
    exportProduct: ['998122266996445', '104750531515506'],
    livechat: {
      pageid: null,
      app: 'facebook,x,pantip',
      type: 'bot',
      loadMonth: 1,
      currentLoadMonth: 1,
      userlist: {
        admin: {
          offset: 0,
          loading: false,
          limit: 20,
          users: [],
          isAutoRefresh: true,
          hasMore: true,
          hasNew: false
        },
        bot: {
          offset: 0,
          loading: false,
          limit: 20,
          users: [],
          isAutoRefresh: true,
          hasMore: true,
          hasNew: false
        }
      },
      monobopages: [
        '148831989096546',
        '1229692217050821',
        '135565533158593',
        '488563718210335',
        '799590883441878'
      ],
      currentUser: null,
      currentUserTicket: [],
      currentUserTicketLoading: false,
      chatlog: [],
      loadingChatlog: true,
      limitFatchChatlog: 20,
      maxFatchChatlogTime: 120000, // 2 min
      limitFatchUser: 20,
      maxFetchUserTime: 120000, // 2 min,
      maxFatchReadTime: 120000, // 2 min,
      filter: {
        search: '',
        status: null,
        tags: [],
        app: '',
        adminread: null
      },
      tags: [],
      notiunread: {},
      platform_type: 'inbox', // inbox | post
      inbox: 'admin' // admin | bot
    },
    modal: {
      input: {},
      component: null,
      open: false,
      width: '600px'
    },
    allSchools: [],
    filter: {
      search: '',
      uuAreaName: '',
      uu_register_status: '',
      lineid: '',
      uu_name: '',
      phoneno: '',
      keyword: ''
    },
    presets: presets.data,
    premiums: premiums.data,
    progress: 0,
    UnlimitedConversation: [
      '100436434784238',
      '103530654454270',
      '1469559653364545',
      '105696154492400',
      '103955724454263', //TestMootest
      '177735408970104'
    ],
    pageProfile: null,
    loadingPageProfile: true,
    shippinglist: [],
    partnerProfile: null,
    loadingPartnerProfile: true,
    ntnPage: NTN_PAGE,
    adsSimulatorPage: ADS_SIMULATOR_PAGE,
    centralPage: [
      '110710877332627',
      '160733491520',
      '107235216024674',
      '394274810994296', //จี้เส้น
      '392612533487',
      '103551424764072',
      '392612533487',
      '11462159325207',
      '114621593252079',
      '134297248716',
      '408054729252920',
      '122424499005',
      '122424499005',
      '408054729252920',
      '122424499005',
      '102421048239798',
      '105928254552462'
    ],
    loadingAgentGroups: false,
    agentGroups: [],
    loadingAgentSubgroups: false,
    agentSubgroups: [],
    loadingAgents: false,
    agents: [],
    admingroupid: Vue.localStorage.get('admingroupid'),
    adminsubgroupid: Vue.localStorage.get('adminsubgroupid'),
    privilege:
      Vue.localStorage.get('privilege') && Vue.localStorage.get('privilege') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('privilege'))
        : [],
    toapainterpage: ['102915644812388'],
    toacustomerpage: ['102968804806798', '148559413337'],
    toadealerpage: ['102028964902390'],
    toaNewDealerPage: ['109436881553235'],
    toaPaintPage: ['107999415145694', '148559413337'],
    menubypageid: {
      104907684692250: ['comment', 'dashboard']
    },
    supertenpage: ['104665701343082', '154660564561038'],
    kfcpage: ['106855151601601', '102052945584054'],
    facebook_users_name: [],
    subcategory: ['116989963422911', '1775425925847885'],
    livechatadminreadpage: ['394274810994296', '208321456497173', '103267601317473'],
    shoptheme: SHOP_THEME_LIST,
    beavermanpage: ['103003014894231'],
    niveapage: ['133498913379485', '125865357450484'],
    thailandPostmartPage: ['115414076948160', '396306053873110'],
    astonAdmins: [],
    loadingAstonAdmins: false,
    astonCustomerGroup: [
      'อื่นๆ',
      'รอสรุปยอด',
      'ร้องเรียน',
      'เปลี่ยนเบอร์-ที่อยู่',
      'โอนเงิน',
      'สั่งซื้อ',
      'ยกเลิก',
      'สั่งซื้อlive',
      'สนใจ',
      'หลังการขาย',
      'ปัญหา'
    ],
    selectedCom7page: {
      name: 'All',
      pageid: null
    },
    gbprimetheme: ['ecommercebasic'],
    com7pages: [
      {
        name: 'Banana',
        pageid: '126654220708334'
      },

      {
        name: 'Studio7',
        pageid: '346030320266'
      }
    ],
    nestlePages: [
      {
        name: 'Nestle Health Science Thailand',
        pageid: '1037700739663223'
      },
      {
        name: 'Test Nestle',
        pageid: '108234815144840'
      },

      {
        name: 'Test Nestle 2',
        pageid: '101542172593323'
      },
      {
        name: 'Nestle Health Science: Boost TH',
        pageid: '110981841237323'
      }
    ],
    bbqPage: ['200701213291845', '106240318558522', '104767375443976'],
    bbqTestPage: ['106240318558522', '104767375443976'],
    newDeshboard: ['361231620965547'],
    rabbitPage: ['108973710878860', '326180737483767', '101760532365601'],
    rabbitReplyFBPostPage: ['101760532365601', '326180737483767'],
    lamyPage: ['102370245472711', '2037301563028410'],
    oceanlifePage: ['110549014810557', '1541081009538378'],
    toacrmrewardcategories: [],
    toacrmbranch: [],
    toacrmpointdata: {},
    toacrmProductName: [],
    toacrmProductMarketing: [],
    toacrmProductSubMarketing: [],
    toaEcouponStore: [],
    toaEcouponProducts: [],
    toaEcouponRewardCategories: [],
    toaEcouponCampaigns: [],
    toaEnableCampaignList: [],
    newchatnotify: {},
    iccpage: [
      '103669308635970',
      '101294872210698',
      '102944058709341',
      '102054622133230',
      '107898204895323',
      '182366355126026',
      '135625339853652',
      '103669308635970',
      '236020493215058',
      '347753078624',
      '104845608724391',
      '110218459027409'
    ],
    prudentialPage: ['102126962268028'],
    prudentialRealPage: ['111901618984646'],
    powerbuyTest: ['105344925152387'],
    gpfPage: ['106004118709627'],
    ticketPageid: [
      '106004118709627',
      '104337274602594',
      '100260714951032',
      '495271297476302',
      '105017609020919',
      '1637674519806774',
      '104662695835182',
      '113282044961669',
      '103238152679894',
      '110614952012250',
      '178316699484910',
      '102901306098188'
      // '116388304732570' //Test TTB
    ],
    toacrmproducts: [],
    delayImportUserTime:
      Vue.localStorage.get('delayImportUserTime') &&
      Vue.localStorage.get('delayImportUserTime') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('delayImportUserTime'))
        : [],

    intents: undefined,
    loadingIntents: true,
    selectToaCampaign: null,
    rabbitSelectedPostId: null,
    status: undefined,
    tags: undefined,
    beaconMasterData: {
      groupAudience: [],
      beaconBranch: []
    },
    hopinnMasterData: {
      position: [],
      affiliation: []
    },
    gpfBuddyMasterData: {
      company: [],
      workGroup: [],
      department: [],
      position: []
    },
    juzMatchMasterDataCrm: [
      { id: 'All', name: 'ทั้งหมด' },
      {
        id: 'invester',
        name: 'นักลงทุน'
      },
      {
        id: 'buyer',
        name: 'ผู้เช่าซื้อ'
      }
    ],
    juzMatchMasterDataSale: [
      { id: 'All', name: 'ทั้งหมด' },
      {
        id: 'invester',
        name: 'สนใจลงทุน'
      },
      {
        id: 'buyer',
        name: 'สนใจเช่าซื้อ'
      },
      {
        id: 'seller',
        name: 'ฝากขายทรัพย์'
      }
    ],

    lamyFilterProductMasterData: {
      categories: [],
      colours: [],
      headtypes: [],
      models: [],
      product_names: [],
      sizes: [],
      branch: []
    },
    rootsMasterData: {
      company: []
    },
    bbqStatusColor: null,
    powerbuyBranchList: [],
    powerbuyMainBranch: null,
    defaultBubbleList: [
      'text',
      'button',
      'image',
      'generic',
      'video',
      'welcome_message',
      'line_flex',
      'line_imagemap',
      'line_sticker',
      'payment_form',
      'add_cart',
      'ntn_template'
    ],
    generaliGameSetting: null,
    ticketTags: null,
    ticketTagsFull: null,
    ticketTagsPageId: null,
    nvbbDroppointLocationOptions: NVBB_DROPPOINT_LOCATION_OPTIONS,
    intentTemplateData: [
      {
        name: 'Tone of voices',
        desc: 'ใช้สำหรับตรวจจับเมื่อลูกค้าส่งคำลงท้ายมาให้เช่น ครับ ค่ะ',
        icon: 'couple.png',
        recommended: true,
        intentName: 'Template - Tone of voices คำลงท้าย',
        val: 'ค่ะ,ครับ,ข่ะ,ค้า,ค๊า,ค่า,คับ,คร้าบ,คร้าฟ,คร้าป,คัฟ,งับ,โอเช,ok,คะ,ค้ะ,ค๊ะ,ค๋า,ข๋า,จ้า,จ้ะ,จ่ะ,จ้รา,จร้า,จร๊า,จ๊า,จ๋า'
      },
      {
        name: 'Profanity',
        desc: 'ใช้สำหรับตรวจจับเมื่อลูกค้าส่งคำไม่สุภาพมาให้',
        icon: 'profanity.png',
        recommended: true,
        intentName: 'Template - Profanity คำไม่สุภาพ',
        val: 'ห่วยแตก,กวนตีน,กวนตรีน,หัวร้อน,รำคาญ,includes(ขอด่า),includes(เกลียด),includes(fuck),includes(bitch),includes(suck),includes(โง่),includes(สลิ่ม),includes(มึง),includes(หน้าด้าน),includes(เหี้ย),includes(เหรี้ย),includes(พ่อง),includes(ประสาท),includes(กวนตีน),includes(หัวร้อน),includes(ควาย),includes(นรก),includes(ถุย),includes(รำคาญ),includes(รำคาน),includes(ลำคาน),includes(ลำคาญ),includes(ห่วย)'
      },
      {
        name: 'Image',
        desc: 'ใช้สำหรับตรวจจับเมื่อลูกค้าส่งรูปภาพมาให้',
        icon: 'img.png',
        recommended: true,
        intentName: 'Template - Image รูปภาพ',
        val: '{image}'
      },
      {
        name: 'Template - URL (Link)',
        desc: 'ใช้สำหรับตรวจจับเมื่อลูกค้าส่งลิงก์มาให้',
        icon: 'link.png',
        recommended: false,
        intentName: 'Template - URL (Link) หรือ ลิงก์',
        val: '{url},includes(bit.ly),startswith(http),startswith(https),startswith(www.),endswith(.co),endswith(.com),endswith(.th)'
      },
      {
        name: 'Audio',
        desc: 'ใช้สำหรับตรวจจับเมื่อลูกค้าส่งไฟล์เสียงมาให้',
        icon: 'sound-wave.png',
        recommended: false,
        intentName: 'Template - Audio ไฟล์เสียง',
        val: '{audio}'
      },
      {
        name: 'Video',
        desc: 'ใช้สำหรับตรวจจับเมื่อลูกค้าส่งไฟล์วีดีโอมาให้',
        icon: 'play.png',
        recommended: false,
        intentName: 'Template - Video ไฟล์วีดีโอ',
        val: '{video}'
      },
      {
        name: 'Location',
        desc: 'ใช้สำหรับตรวจจับเมื่อลูกค้าแชร์ตำแหน่งที่ตั้งมาให้',
        icon: 'map.png',
        recommended: false,
        intentName: 'Template - Location ตำแหน่งที่ตั้ง',
        val: '{location}'
      },
      {
        name: 'Emoji',
        desc: 'ใช้สำหรับตรวจจับเมื่อลูกค้าส่งอีโมจิมาให้',
        icon: 'smile.png',
        recommended: false,
        intentName: 'Template - Emoji อีโมจิ',
        val: '{emoji}'
      },
      {
        name: 'Sticker',
        desc: 'ใช้สำหรับตรวจจับเมื่อลูกค้าส่งสติ๊กเกอร์มาให้',
        icon: 'sticker.png',
        recommended: false,
        lineText: 'Only LINE OA',
        intentName: 'Template - Sticker สติ๊กเกอร์',
        val: '{sticker}'
      },
      {
        name: 'Interested/Order',
        desc: '',
        icon: '',
        iconText: '🛒',
        recommended: false,
        intentName: 'Template_สั่งซื้อสินค้า',
        val: 'ขอสั่งซื้อ1ชุดครับ,สั่งซื้อสินค้า,ต้องสั่งซื้อยังไงครับ,ขอดูสินค้าทั้งหมดหน่อยค่ะ,ขอดูสินค้าคะ,ต้องการเลือกสินค้าค่ะ,มีสินค้าอยู่ไหมคะ,สั่งสินค้าหน่อยค่า,ขอดูสินค้า,ยังมีสินค้านี้ยุมั้ยค่ะ,สนใจสินค้า,สนใจสินค้าทางร้านค่ะ,สามารถเลือกดูสินค้าได้จากลิ้งเลยใช่มั้ยคะ,ขอดูสินค้าที่มีด้วยนะค่ะเพื่อนจะสั่งค่ะ,ดูสินค้าตรงไหนคะ,มีสินค้าแบบใหม่ไหมคะ,สั่งซื้อสินค้า,สินค้าพร้อมส่งใช่ไหมคะ,ขอดูสินค้าหน่อยค่ะ,สนใจสั่งสินค้าค่ะ,สินค้าจะมีลายใหม่มาลงมั้ยคะ,เลือกสินค้าในนี้ได้เลยใช่มั๊ยคะ,ขอดูสินค้าหน่อยคะ,ขอดูแบบสินค้าคะ,ถ้าจะรบกวนขอรูปสินค้าได้มั้ยคะ,ยังมีสินค้าไหมคะ,ยังมีสินค้ามั้ยคะ,สั่งสินค้าเพิ่มได้ไหมค่ะ,สั่งสินค้าได้ทางไหนค่ะ,สินค้าตัวไหนพร้อมส่ง,ยังมีสินค้าไหมคะ,สนใจสินค้า,สนใจสินค้าค่ะ,มีสินค้าพร้อมส่งไหมคะ,ขอดูสินค้าได้ไหมค่ะ,สนใจสินค้าค่ะ,สั่งสินค้าค่ะ,สนใจสินค้า,สนใจสอบถามคะ,includes(สนใจ&&สั่งซื้อ),includes(สั่ง&&ยังไง),includes(สั่ง&&อย่างไร),includes(ซื้อ&&สินค้า),includes(สนใจ&&สั่ง),includes(ต้องการ&&สั่ง),includes(สั่ง&&ทางไหน),includes(สั่ง&&ที่ไหน),includes(สนใจ&&ซื้อ),includes(ซื้อ&&สินค้า),includes(สอบถาม&&ซื้อ),includes(ซื้อ&&ยัง),exacts(สนใจสั่งซื้อ),exacts(สั่งซื้อสินค้า),exacts(ดูสินค้าทั้งหมด)'
      },
      {
        name: 'Promotion',
        desc: '',
        icon: '',
        iconText: '🎊',
        recommended: false,
        intentName: 'Template_โปรโมชั่น',
        val: 'มีโปรอะไรบ้าง,มีโปรโมชั่นอะไรบ้างคะ,มีโปรโมชั่นอะไรบ้าง,มีPromotionอะไรบ้างขอโปรโมชั่นหน่อยค่ะ,แนะนำโปรโมชั่นหน่อยค่ะ,มีโปรอะไรแนะนำไหมคะ,มีโปรโมชั่นบ้างไหนคะ,มีโปรไหมคะตอนนี้,มีโปรอะไรบ้างคะ,ตอนนี้มีโปรอะไรบ้างคะ,มีโปรแนะนำไหมคะ,จัดโปรไหมคะตอนนี้,ช่วงนี้มีโปรไหมคะ,มีส่วนลดมั้ยคะ,มีโปรโมชั่นอะไรไหมคะ,ช่วงนี้มีโปรอะไรบ้างคะ,ดูโปรโมชั่นปัจจุบัน,โปรโมชั่นทั้งหมด,มีโปรอะไรไหมคะ,มีโปรไหมคะ,มีโปรมั้ยคะ,ตอนนี้มีโปรโมชั่นอะไรบ้างคะ,ขอดูโปรนี้หน่อยค่ะ,ตอนนี้มีโปรแบบไหนบ้างคับ,ช่วงนี้ไม่มีโปรเหรอ,ช่วงนี้มีโปรอะไรบ้าง,ดูสินค้าพวกจัดโปร,มีโปรอีกมั้ย,มีโปรลดราคามั้ยคะ,หมดโปรยังคับ,โปรถึงเดือนไหน,รอโปรโมชั่นต่อไป,มีโปรดีๆป่าว,โปรหมดยังคับ,ตอนนี้มีโปรรึป่าวครับ,มีโปรมั้ยคับ,มีโปรไหมคับ,ช่วงนี้มีโปรลดราคาสินค้าบ้างหรือเปล่าคะ,ราคาแบบโปรใช่ไหมค่ะ,โปรโมชั่นเดือนนี้มีอะไรบ้างคะ,ตอนนี้มีโปรแบบไหนบ้างคับ,ขอดูโปรนี้หน่อยคะ,หมดโปรยัง,รอโปรโมชั่น,มีโปรดีๆป่าว,includes(โปรโมชัน),includes(โปรโมชั่น),includes(Promotion),includes(ส่วนลด),includes(มี&&โปร),includes(สอบถาม&&โปร),includes(ดู&&โปรโมชั่น),includes(สนใจ&&โปร),exacts(โปรโมชั่น),exacts(Promotion)'
      },
      {
        name: 'Date/Business hours',
        desc: '',
        icon: '',
        iconText: '⏰',
        recommended: false,
        intentName: 'Template_วัน-เวลาทำการ',
        val: 'ร้านเปิดทุกวันไหมคะ,ร้านเปิดมั้ยครับ,ร้านเปิดยังค่ะ,วันนี้ร้านเปิดรึเปล่าคะ,หน้าร้านเปิดกี่โมงนะคะ,พรุ่งนี้ร้านเปิดปกติใช่ไหมคะ,วันนี้ร้านเปิดมั้ยครับ,วันนี้ร้านเปิดมั้ยคะ,สวัสดีค่า วันนี้ร้านเปิดไหมค่า,ร้านปิดกี่โมงคะ,วันนี้ร้านปิดเหรอคะ,เปิดกี่โมงคะ,ปิดกี่โมงคะ,ร้านปิดกี่โมงคะ,includes(เวลา เปิด - ปิด),includes(เปิดกี่โมง),includes(ปิดกี่โมง),includes(เวลาเปิด),includes(เวลาปิด),includes(เปิด&&ตอนไหน),includes(ปิด&&ตอนไหน),includes(เปิด&&กี่โมง),includes(เปิด&&เวลา),includes(เปิด&&ยัง&&คะ),includes(เปิด&&ยัง&&ครับ),includes(เปิด&&เมื่อไหร่),includes(เปิด&&กี่&&โมง),includes(เวลา&&ร้าน&&เปิด),includes(เวลา&&ปิด),includes(ปิด&&เมื่อไหร่),exacts(เวลาเปิด),exacts(เวลาปิด),exacts(เวลาทำการ)'
      },
      {
        name: 'Telephone',
        desc: '',
        icon: '',
        iconText: '📞',
        recommended: false,
        intentName: 'Template_เบอร์ติดต่อ',
        val: 'ขอเบอร์ติดต่อด้วยคะ,ขอเบอร์โทรศัพท์หน่อยค่ะ,ขอเบอร์โทรครับ,ขอเบอร์โทรหน่อยครับ,ขอเบอร์โทรติดต่อหน่อยได้ไหมค่ะ,ติดต่อเบอร์ไหน,มีเบอร์ติดต่อกลับหากสินค้าชำรุดเสียหายมั๊ย,มีเบอร์ที่ติดต่อไหมครับ,มีเบอร์ไหม,เบอร์อะไรคะ,ขอเบอร์โทรครับ,ขอเบอร์ที่สามารถติดต่อเจ้าหน้าที่ได้,ขอทราบเบอร์โทรติดต่อหน่อยได้หรือป่าวครับ,ขอเบอร์คอลเซ็นเตอร์หน่อยครับ,ขอเบอร์หน่อยครับ,มีเบอร์ติดต่อมั้ยคับ,มีเบอร์ทางร้านมั้ยจะได้โทรคุย,รบกวรขอเบอร์โทรติดต่อโดยตรงก็ได้นะค่ะ,มีเบอร์โทรติดต่อรึเปล่าคะ,เบอร์โทรศัพท์เหรอครับ,รบกวนขอเบอร์ติดต่อได้ไหมคะ,รบกวนขอเบอร์โทรกลับด้วยครับ,ติดต่อที่ใหนครับมี เบอร์โทใหม,มีเบอร์โทรให้คำปรึกษาไหมครับ,มีเบอร์โทรมั้ยคะ,ขอเบอร์ได้ไหมครับไม่ค่อยเข้าใจ,ขอเบอร์หน่อยครับผมโทรเลยดีกว่า,ขอเบอร์โทรสอบถามหน่อยครับ,รบกวนขอเบอร์ติดต่อคับ,มีเบอร์ติดต่อไหมครับ อยากคุย,อยากได้เบอร์แอดค่ะ ได้ไหมคะ,ขอเบอร์แอดมินหน่อยคับ,ผมขอเป็นเบอร์โทรศัพย์,มีเบอร์ติดต่อไหมครับ,มีเบอร์โทรติดต่อไหมครับ,มีเบอร์น้องมั้ยเดี๋ยวพี่โทรถามดีกว่า,เบอร์ติดต่อพนักงานมั้ยค่ะ,ขอเบอร์ติดต่อครับผม ติดต่อคุณอะไรครับผม,ขอเบอร์โทรติดต่อหน่อยได้ไหมค่ะ,ขอเบอร์โทรหน่อยครับ,มีเบอร์ติดต่อไหมครับ,มีเบอร์ที่ติดต่อไหมครับ,includes(เบอร์ติดต่อ),includes(เบอร์&&ติดต่อ),includes(โทร&&ติดต่อ),includes(เบอ&&ติดต่อ),includes(โทร&&เบอร์),includes(ติดต่อ&&เบอร์&&ไหน),includes(ขอ&&เบอร์),includes(โทร&&ติดต่อ),includes(ขอ&&เบอ),includes(มี&&เบอร์&&ไหม),includes(โทร&&ได้&&ไหม),includes(โทร&&ได้&&มั้ย),exacts(เบอร์ติดต่อ),exacts(เบอร์โทร),exacts(การติดต่อ)'
      },
      {
        name: 'Contact admin',
        desc: '',
        icon: '',
        iconText: '🙋‍♀️',
        recommended: false,
        intentName: 'Template_ติดต่อแอดมิน',
        val: 'รบกวนสอยถามแอดมินหน่อยค่ะ,รบกวน แอดมิน ตรวจสอบสินค้าให้หน่อย,สอบถามหน่อยครับแอดมิน,แอดมินติดตามของไห้หน่อยคะ,ขอคำแนะนำน่อยคับแอดมิน,ตอบหน่อยค่าแอดมิน,รบกวนแอดมิน แนะนำให้ด้วยครับ,แอดมินตอบด้วยนะคะ,แอดมินตอบช้ามาก,สอบถามแอดมิน,ติดต่อเจ้าหน้าที่,ยังไม่มีเจ้าหน้าที่อ่านเลยคะ,ไม่คุยกับบอท,includes(ติดต่อแอดมิน),includes(คุยกับแอดมิน),includes(ติดต่อเจ้าหน้าที่),includes(ติดต่อ&&admin),includes(contact&&admin),includes(คุยกับคน),includes(ไม่คุย&&บอท),includes(ไม่เอา&&บอท),includes(คุย&&เจ้าหน้าที่),exacts(ติดต่อแอดมิน),exacts(คุยกับแอดมิน),exacts(คุยกับคน),exacts(contact admin)'
      },
      {
        name: 'Store map',
        desc: '',
        icon: '',
        iconText: '📍',
        recommended: false,
        intentName: 'Template_แผนที่ร้าน',
        val: 'สอบถามค่ะ แผนที่,ร้านอยุ่ตรงไหนนะ,ร้านอยุ่ตรงไหนนะ,ร้านอยู่ตรงไหนจ้ะ,รบกวนขอแผนที่หน่อยได้ไหมคะ,มีแผนที่ให้ไหมคะ,แอดมินส่งแผนที่ให้หน่อยค่ะ,ขอแผนที่ได้ไหมครับ,รบกวนส่งโลเคชั่นให้หน่อยครับ,เดินทางไปร้านยังไงคะ,วิธีการเดินทางไปร้าน,รบกวนขอตำแหน่งด้วยค่ะ,includes(แผนที่ร้าน),includes(ตำแหน่งร้าน),includes(อยู่&&ที่ไหน),includes(ไป&&อย่างไร),includes(ไป&&ยังไง),includes(วิธี&&เดินทาง),includes(ขอ&&แผนที่),includes(วิธี&&การไป),includes(ขอ&&โลเคชั่น),includes(มี&&แผนที่&&ไหม),includes(ขอ&&แผนที่&&หน่อย),includes(ร้าน&&อยู่ไหน),includes(ตำแหน่ง&&ร้าน),includes(การไปร้าน),includes(ไป&&อย่างไร),exacts(แผนที่ร้าน),exacts(ตำแหน่งร้าน),exacts(ที่อยู่ร้าน)'
      },
      {
        name: 'Shipping cost',
        desc: '',
        icon: '',
        iconText: '🛵',
        recommended: false,
        intentName: 'Template_ค่าส่งสินค้า',
        val: 'รวมค่าส่งทั้งหมดเท่าไหร่คับ,เสียค่าส่งไหมค่ะ,โอนเสียค่าส่งไหม,รวมค่าส่งหรือยังครับ,รวมค่าส่งแล้วใช่มั๊ยคะ,ค่าส่งกี่บาทครับ,ค่าส่งลดได้ไหม,ไม่ฟรีค่าส่งหรือครับ,รวมค่าส่งเท่าไรคับ,ฟรีค่าส่งมั่ยครับ,คิดค่าส่งยังไงครับ,คิดค่าส่งไหม,ค่าส่งเท่าไหร่ค่ะ,รวมค่าส่งยังคับ,มีค่าส่งไหมค่ะ,โอนมีค่าส่งไหมค่ะ,โอนนี่ฟรีค่าส่งมั้ยครับ,เสียค่าส่งมั้ยค่ะ,ส่งฟรี หรือ มีบวกค่าส่งค่ะ,ถ้าโอนเสียค่าส่งไหมคับ,ค่าส่งเท่าไหร,ค่าส่งเท่าไหร่ค่ะ,สรุปว่ามีค่าส่งมั้ยค่ะ,เสียค่าส่งไหมคะ,ถ้าโอนลดค่าส่งไหมครับ,ทำใมคิค่าส่งด้วย,โอนมีค่าส่งไหมคะ,มีค่าส่งเพิ่มไหม,ไม่ฟรีค่าส่งเหรอคะ,โอนไม่มีค่าส่งเปล่า,โอนจ่ายรวมค่าส่งเท่าไหร่ครับ,รวมค่าส่งยังครับ,includes(ค่าส่ง&&เท่าไหร่),includes(ขอ&&ค่าส่ง),includes(ราคา&&ค่าส่ง),includes(ค่าส่ง&&สินค้า),includes(เสีย&&ค่าส่ง&&ไหม),includes(เสีย&&ค่าส่ง&&มั้ย),includes(ค่าส่ง&&กี่บาท),includes(ฟรี&&ค่าส่ง),includes(สอบถาม&&ค่าส่ง),includes(เรท&&ค่าส่ง),exacts(ค่าส่ง)'
      },
      {
        name: 'Account number',
        desc: '',
        icon: '',
        iconText: '📲',
        recommended: false,
        intentName: 'Template_เลขบัญชี',
        val: 'พร้อมโอนค่ะ,พร้อมโอนครับ,แบบโอนคับ,เลขโอนเข้า,ขอโอนแระกันค่า,วันนี้โอนบัญชีเงินได้ไหม,สะดวกโอนได้ป่าว,ขอโอนนะครับ,จะโอนเลยขอบัญชีด้วย,ขอบัญชีคะ,ขอบัญชีครับ,โอนบัญชีไหนครับ,ขอเลขที่บัญชีครับ,ขอเลขที่บัญชีค่ะ,บัญชีนี้นะครับ,บัญชีมาค่ะ,ขอบัญชีชื่ออะไร,ขอโทษด้วย ขอโอนบัญชีได้ไหม,ขอเลขที่บัญชีค่ะ,ขอเลขที่ บช,มีเลข บัญชีไหมคับ,includes(เลข&&บัญชี),includes(โอน&&ยังไง),includes(โอน&&ที่ไหน),includes(ขอ&&เลข&&บัญชี),includes(ขอ&&เลข&&บช),includes(โอน&&ยังไง),includes(โอน&&อย่างไร),includes(โอน&&บช),includes(พร้อม&&โอน),includes(ธนาคาร&&อะไร),includes(ขอ&&บัญชี),includes(ขอ&&บันชี),exacts(เลขบัญชี)'
      },
      {
        name: 'Cash on delivery',
        desc: '',
        icon: '',
        iconText: '🚛',
        recommended: false,
        intentName: 'Template_เก็บเงินปลายทาง',
        val: 'เก็บปลายทางมีค่าส่งมั้ยค่ะ,รวมค่าส่งปลายทางเท่าไหร่ค่ะ,สนใจ เก็บปลายทางนะคะ,ค่าส่งเก็บปลายทางเท่าไหร่คะ,เก็บเงินปลายทางมีค่าส่งหรือเปล่าครับ,เก็บปลายทางเท่าไรค่ะ,เก็บปลายทางบวกเพิ่มไหมคะ,เก็บปลายทางอย่างเดียวใช่มั๊ยคับ,ส่งปลายทาง,อันนี้เก็บปลายทางไมคะ,สรุปชำระเงินปลายทางเท่าไหร,จ่ายเงินปลายทางคับ,ชำระปลายทางคับ,ชำระเงินปลายทางครับ,ชำระแบบเก็บเงินปลายทางครับ,พร้อมส่งปลายทางเท่าไหร่ครับ,รวมเท่าไรปลายทางครับ,รับค่ะเก็บปลายทาง,ราคารวมปลายทางเท่าใหร่,ราคารวมเก็บเงินปลายทางยังคับ,แบบเก็บเงินปลายทางใช่มั้ยครับ,เอาปลายทางคับ,ชำระปลายทางครับ,มีแบบชำระปลายทางมั้ยคะ,รับคะ ปลายทาง,เก็บปลายทางอย่างเดียวใช่ไหมคะ,มีบริการเก็บปลายทางไหมคะ,ยอดจ่ายปลายทางเท่าไหร่คะ,มีบริการเก็บปลายทางไหมค่ะ,จ่ายปลายทาง,เก็บปลายทางได้ใช่มั้ยคะ,เก็บเงินปลายทางมีบวกเพิ่มไหมครับ,ได้ครับเก็บเงินปลายทางครับ,เก็บเงินปลายทาง รวมส่งเท่าไหร่ครับ,จ่ายปลายทางไหมคับ,จัดส่ง เก็บเงินปลายทางครับ,ชำระปลายทาง,จ่ายปลายทางครับ,มีบริการเก็บเงินปลายทางไหม,เอาเก็บปลายทางครับ,เอาแบบเก็บเงินปลายทางค่ะ,เก็บเงินปลายทางราคาเดียวกันหรือเปล่าครับ,เก็บเงินปลายทางอย่างเดียวใช่มัยคะ,เก็บปลายทางเท่าไหร่คับ,เก็บปลายทางครับ,สั่งแบบเก็บเงินปลายทางค่ะ,เก็บเงินปลายทาง บวกเพิ่มหรือเปล่า,เป็นบริการปลายทางใช่ไหมคะ,includes(มี&&ปลายทาง),includes(เก็บเงินปลายทาง),includes(เก็บ&&ปลายทาง),includes(จ่าย&&ปลายทาง),includes(มี&&ปลายทาง),includes(ปลายทาง&&ได้ไหม),includes(ปลายทาง&&ได้มั้ย),includes(ชำระ&&ปลายทาง),includes(บริการ&&ปลายทาง),includes(ราคา&&ปลายทาง),includes(เก็บ&&ปายทาง),includes(บวกเพิ่ม&&ปลายทาง),includes(ปลายทาง&&เท่าไหร่),exacts(เก็บเงินปลายทาง),exacts(COD)'
      },
      {
        name: 'Pay via Credit card',
        desc: '',
        icon: '',
        iconText: '💳',
        recommended: false,
        intentName: 'Template_ชำระผ่านบัตรเครดิต',
        val: 'จ่ายผ่านบัตรเครดิตได้ไหมคะ,จ่ายบัตร credit ได้หรือไม่,ที่ร้านรับบัตรเครดิตไหมคะ,จ่ายด้วยบัตรเครดิตค่ะ,ตัดผ่านบัตรเครดิตได้มั้ยค่ะ,จ่ายผ่านบัตรค่ะ,ถ้าตัดบัตรเครดิต มีไหมคะ,จะชำระผ่านบัตรเลยได้ไหมครับ,ชำระผ่านบัตรเครดิตได้มั้ยหรือโอนครับ,พอมีช่องทางชำระผ่านบัตรมั้ยครับ,มีบริการตัดผ่านบัตรเครดิตมั้ยค่ะ,ใช้บัตรเครดิตจ่ายได้มั้ยคะ,ใช้บัตรเครดิตได้มั้ยคะ,มีบริการตัดผ่านบัตรเครดิตมั้ยค่ะ,จ่ายผ่านบัตรเครดิตได้หรือเปล่าค่ะ,ตัดบัตรได้ไหมคะ,includes(บัตรเครดิต),includes(ตัดบัตร),includes(จ่าย&&บัตร),includes(ตัด&&เครดิต),includes(รับ&&บัตร&&ไหม),includes(รับ&&บัตร&&มั้ย),includes(ชำระ&&ผ่าน&&บัตร),includes(ใช้&&บัตร&&เครดิต),includes(ใช้บัตร&&ได้ไหม),includes(ใช้&&บัตร&&ได้มั้ย),includes(บริการ&&ตัดบัตร),includes(บริการ&&บัตร),includes(ตัดบัตร&&ได้มั้ย),includes(ตัดบัตร&&ได้ไหม),includes(จ่าย&&ด้วย&&บัตร),exacts(บัตรเครดิต),exacts(บัตรเดบิด)'
      },
      {
        name: 'Pay by Installments',
        desc: '',
        icon: '',
        iconText: '💰',
        recommended: false,
        intentName: 'Template_การผ่อนชำระ',
        val: 'ขอดูโปรผ่อนค่ะ,ขอแบบผ่อนจ่าย,ผ่อนจ่ายนี่รายละเอียดยังไงคะ,ผ่อนบัตรเครดิตได้ใช่ไหมคะ,ผ่อนเงินสดคะ,ผ่อนเดือนเท่าไหร่คะพี่,ผ่อนแบบโอน เป็นยังไงครับ,ผ่อนแบบไม่ใช้บัตร ได้ไหมครับ,ผ่อนได้ไหมครับ,มีผ่อนแบบไม่รูดบัตรไหมคะ,สามารถผ่อนแบบไหนได้บ้างหรอครับ,ผ่อน เดบิต ก็ได้ใช่ไหมคะ,อยากผ่อนชำระ แต่ไม่มีบัตรเดบิตเลยค่ะ,ไม่ทราบว่ามีผ่อนจ่ายไหมครับ,คือผ่อนตรงกับทางคุณเลยใช่ไหมคะ,ต้องผ่อนผ่านบัตรใช่ไหมครับ,ต้องผ่อนกี่เดือนครับ,จ่ายเงินสดมีแบบผ่อนด้วยใช่ไหมค่พ,ต้องผ่อนผ่านบัตรใช่ไหมครับ,มีผ่อนชำระมั้ยคะ,มีผ่อนบัตร เครดิตมั้ยครับ,ผ่อนบัตรเครดิต,มีแบบผ่อนชำระไหมครับ,รูดบัตร หรือ ผ่อนได้มั๊ยคะ,มีโปรพิเศษหรือผ่อนอะไรไหมครับ,includes(การ&&ผ่อน),includes(ผ่อน&&ได้ไหม),includes(ผ่อน&&ได้มั้ย),includes(มี&&ผ่อน&&ไหม),includes(มี&&ผ่อน&&มั้ย),includes(ผ่อน&&ผ่านบัตร),includes(ผ่อน&&เงินสด),includes(รายละเอียด&&ผ่อน),includes(ข้อมูล&&ผ่อน),includes(สนใจ&&ผ่อน),includes(ต้องการ&&ผ่อน),includes(อยาก&&ผ่อน),includes(ขอ&&ผ่อน),includes(โปร&&ผ่อน),includes(ผ่อน&&ชำระ),includes(ผ่อน&&ไม่ใช้&&บัตร),includes(มี&&ผ่อน&&ไหม),includes(มี&&ผ่อน&&มั้ย),includes(ผ่อน&&ชำระ),exacts(การผ่อน)'
      },
      {
        name: 'Delivery cycle/Transportation channel',
        desc: '',
        icon: '',
        iconText: '🎁',
        recommended: false,
        intentName: 'Template_รอบการจัดส่ง',
        val: 'ส่งของ บริษัทอะไรครับ,ส่งของวันไหน,ส่งของจะติดเสาร-อาทิตไหมคะ,ไม่ทราบส่งของให้ผมหรือยังครับ,ส่งของหรือยังคะ ขอเลขพัสดุหน่อยค่า,ส่งของบริษัทอรัยครับ,ขนส่งของcjหรอค่ะ,รบกวนหน่อยคะ ส่งของหรือยังคะ,ใช้เวลากี่วันในการส่งของ,ได้ส่งของแล้วใช่ไหมคะ,พี่ครับพี่ส่งของให้ผมรึยังคับ,วันไหนคะที่จะส่งของ,ชำระเงินแล้ว ส่งของมายังครับ,ขออนุญาตสอบถามครับ ส่งของรึยังครับผม,สอบถามหน่อยค่า ส่งของให้วันไหนคะ, ส่งของวันไหนคะ,ส่งของได้เมื่อไหร่ครับ,แอด ส่งของวันไหนคะ,ไม่ทราบว่าทำการจัดส่งของหรือยังคับ,ไม่ทราบว่าได้ส่งของมาหรือยังค๊า,มิทราบว่าจะจัดนำส่งของวันไหนคะ,พี่ส่งของยังครับ,ส่งของวันไหนคะ ขนส่งอะไรคะ,ว่าส่งของมาหรือยัง,ขอเลขส่งของด้วยค่ะ,ส่งของให้ยังครับ,ส่งของมารึยังคะ,ใช้ขนส่งของอะไรครับ,ใช้ขนส่งอะไรคะ,ส่งขนส่งไรครับ,ส่ง ขนส่งอะไรคะ,ยากทราบว่าบริษัทไหนขนส่ง,ขนส่งอะไรเอ่ย,ขนส่งเดียวกันไหมคะ,ขนส่งอะไรคะ,ส่ง EMS หรือขนส่งเอกชนครับ,ส่ง ขนส่ง เอกชนน่ะ,สอบถามค่ะ ขนส่งของอะไรคะ, ส่งขนส่งอะไรให้ผมครับ,ใช้ขนส่งอะไรครับ,ของถึงวันไหน เช็คยังไงคับ,จะเริ่มส่งของวันไหนคับ,กีวันได้รับ,กี่วันได้รับของค่ะ,ส่งของได้รับประมาณกี่วันคะ,includes(ส่ง&&วันไหน),includes(ส่ง&&เมื่อไหร่),includes(ส่ง&&ตอนไหน),includes(ขนส่ง&&อะไร),includes(ส่ง&&ของ&&ยัง),includes(ส่ง&&เมื่อใด),includes(ส่งของ&&แล้ว&&ไหม),includes(ขนส่ง&&ของ&&อะไร),includes(บริการ&&ขนส่ง),includes(ช่องทาง&&ขนส่ง),includes(ขนส่ง&&เจ้าไหน),includes(ขนส่ง&&แบรนด์ไหน),includes(กี่วัน&&ได้ของ),includes(รอของ&&กี่วัน),includes(เริ่มส่ง&&วันไหน),includes(ส่งของ&&วันไหน),includes(จัดส่ง&&หรือยัง),includes(จัดส่ง&&เมื่อไหร่),includes(บริษัท&&ขนส่ง),includes(ขนส่ง&&ของ&&ที่ไหน),includes(กี่วัน&&ได้ของ),includes(กี่วัน&&ได้รับ),includes(รอ&&กี่วัน&&ส่ง)'
      },
      {
        name: 'Ask for Parcel Number',
        desc: '',
        icon: '',
        iconText: '📦',
        recommended: false,
        intentName: 'Template_ขอเลขพัสดุ',
        val: 'ขอหมายเลขของ,ขอหมายเลขพัสดุหน่อยครับ,ขอเลขพัสดุหน่อยครับ,ขอเลขแทรคได้มั้ยคะ,จัดส่งแล้วขอเลขพัสดุด้วยนะคะ,มีเลขแทคให้เช็คมั้ยค่ะ,ยังไม่มีเลขที่พัสดุมาให้เลย,รอเลขพัสดุให้ดูด้วย,รบกวนขอเลขพัสดุหน่อยครับ อยากเช็คสถานะ,ส่งเลขที่พัสดุมาเลยครับ,ขอเลขพัสดุให้หน่อยอย่าลืมนะ,ขอเลขเช็คพัสดุหน่อยค่ะ,ขอเลขที่พัสดุด้วยนะคะ,ขอเลขพัสดุด้วย,ขอเลข บช,ขอเลขพัสดุหน่อยครับ,จะทราบเลขพัสดุได้จากที่ไหนคะ,อยากทราบเลขพัสดุที่สั่งครับ,ขอเลขพัสดุหน่อยจ้า,ขอเลขที่ส่งสินค้าด้วยครับ,ขอเลขพัสดุด้วย,เช็คเลขพัสดุให้ผมดูหน่อยครับ,ส่งแล้วแจ้งเลขทีนะคับ,หรือมีเลขแทรค รบกวนแจ้งทีจ้า,ส่งของหรือยังคะ ขอเลขพัสดุหน่อยค่า,รอจ้า ยังไงช่วยแจ้งเลขทีนะคับ,เลขพัสดุเช็คยังไงคะ ?,เอาเลขพัสดุเช็คที่ไหนครับ,แจ้งเลขที่พัสดุด้วยนะครับ,ขอเลขที่เช็คพัสดุด้วยครับ,ขอหมายเลขพัสดุด้วยครับ,ขอเลขพัสดุด้วยคับ,ขอเลขพัสดุด้วยนะครับ,พี่ดูเลขพัสดุได้ที่ไหน,ไม่แจ้งเลขพัสดุหรอคะพี่แอดมิน,ไม่เห็นมีเลขแทรคส่งให้เลยสงสัยคะ,ได้เลขพัสดุแล้วช่วยส่งให้พี่ด้วยนะคะ,สอบถามเลขพัสดุสินค้าหน่อยครับ,สอบถามขอเลขพัสดุหน่อย,ขอเลขส่งของด้วยค่ะ,ขอเลขพัสดุด้วยคะ,จะมีเลขพัสดุให้ช่ายมั๊ยคะ,ขอเลขจัดส่งหน่อยค่า,ขอหมายเลขพัสดุด้วยนะคะ,เลขพัสดุก็ยังไม่ได้,รบกวนของเลขส่งครับ,รบกวนขอหมายเลขพัสดุด้วยครับ,มีหมายเลขพัสดุ เช็คสถานะมั้ยครับ,มีเลขติดตามพัสดุไหมครับ,รบกวนขอหมายเลขพัสดุด้วยครับ,ขอเลขแทร็คค่ะ,มีเลขแทร็คไหมคะ เช็คพัสดุ,สรุปจะเช็คเลขพัสดุยังไงค่ะ,ถ้าส่งมาแล้ว ขอเลขพัสดุ ด้วยนะครับ,ถ้าส่งแล้วแจ้งเลขแทร็คในนี้ให้หน่อยนะคะ,จัดส่งรึยังครับรบกวนขอเลขพัสดุด้วยครับ,ส่งแล้วส่งเลขพัสดุให้ด้วยนะครับ,แจ้ง เลขได้วันไหนครับ,ขอหมายเลขพัสดุหน่อยค่ะ,ขอเลขเช็ค ของหน่อยคะ,ทำไมเช็คเลขไม่ได้,รบกวนขอเลขพัสดุค่ะ,รบกวนขอเลขพัสดุหน่อยค่ะ,มีเลขพัสดุให้เช็คมั้ยค่ะ,มีเลขพัสดุไหมครับ,เลขพัสดุมีมั้ยครับ,มายังเลข ems,ถ้าส่งมาแล้ว ขอ เลขพัสดุด้วยนะคับ,ขอหมายเลขพัสดุหน่อยค่ะ,ขอเลขพัสดุคะ,เสร็จแล้ว แจ้งเลข มาครับ,เช็คเลขวัสดุให้หน่อยได้ไหมครับ,ส่งยังคงรับขอเลขหน่อย,includes(เลขพัสดุ),includes(ขอเลข&&พัสดุ),includes(เช็ค&&พัสดุ),includes(เช็ค&&เลข&&ที่ไหน),includes(เช็ค&&เลข&&ยังไง),includes(ตรวจสอบ&&เลข),includes(ตรวจสอบ&&พัสดุ),includes(ขอเลข&&พัสดุ),includes(แจ้ง&&เลข&&พัสดุ),includes(เช็ค&&เลข),includes(หมายเลข&&พัสดุ),includes(เช็ค&&สถานะ&&พัสดุ),includes(สถานะ&&พัสดุ),exacts(เลขพัสดุ)'
      },
      {
        name: 'Storefront',
        desc: '',
        icon: '',
        iconText: '🏪',
        recommended: false,
        intentName: 'Template_หน้าร้าน',
        val: 'ซื้อผ่านหน้าร้าน,มีหน้าร้านใหมคับ,หน้าร้านอยู่แถวไหนครับ,หน้าร้านอยู่ไหนคับ,มีหน้าร้านไหมค่ะ,มีหน้าร้านไหมครับ,มีรับหน้าร้านไหมครับ,มีหน้าร้านหรือป่าวค่ะ,มีหน้าร้านไหมครับ ถ้ามี มีที่ไหนบ้างครับ,มีหน้าร้านมั้ยคะ พอดีรีบใช้ค่ะ,มีหน้าร้านไหม,มีหน้าร้านมั้ย,includes(มี&&หน้าร้าน),includes(หน้าร้าน&&อยู่ไหน),includes(รับ&&หน้าร้าน),includes(ซื้อ&&หน้าร้าน),includes(ไป&&หน้าร้าน),exacts(หน้าร้าน)'
      },
      {
        name: 'Ask for review',
        desc: '',
        icon: '',
        iconText: '🎉',
        recommended: false,
        intentName: 'Template_ขอดูรีวิว',
        val: 'มีรีวิวมั้ยครับ,มีรีวิวไหมคับ,มีรีวิวหน่อยค่ะ,มีรีวิวไม่คะ,มีรีวิวลูกค้ามั้ยคะ,มีคลิปรีวิวสินค้าไหมคะ,มีคลิปรีวิวมั้ยค่ะ,includes(ขอ&&รีวิว),includes(รีวิว&&เพิ่มเติม),includes(รีวิว&&ทั้งหมด),includes(ขอ&&รีวิว&&หน่อย),includes(รูป&&รีวิว),includes(คนใช้&&จริง),includes(รีวิว&&เพิ่มเติม),includes(ดู&&review),includes(ขอ&&review),exacts(รีวิว)'
      },
      {
        name: 'Wholesale Price',
        desc: '',
        icon: '',
        iconText: '📣',
        recommended: false,
        intentName: 'Template_ราคาส่ง',
        val: 'มีราคาส่งไหมครับ,มีเรทราคาส่งมั้ยคะ,ขอราคาส่งค่ะ,ที่บอกสั่งเยอะมีราคาส่ง เยอะแค่ไหนคับ,มีราคาส่งสำหรับร้านค้าไหมครับ,มีราคาส่งไหมครับ,ราคาส่งจะนำมาจำหน่ายต่อคิดยังไงครับ,ขายส่งไมคะ,มีขายส่งใหมครับ,ปกติขายส่งด้วยไหมครับ,ขอดูงานราคาส่งค่ะ,ขอดูเรทราคาส่งหน่อยค่ะ,ขอทราบเรทราคาส่งค่ะ,ขอราคาส่งหน่อยจ้า,ขอรายละเอียด ราคาส่งคะ,ขอเรทราคาส่งค่ะ,ขอเรทราคาส่งจ้า,ต้องรับกี่ตัวถึงได้ราคาส่งคะ,ราคาส่งต้องสั่งกี่ตัวคะ,ราคาส่งต้องเอากี่ตัวขึ้นไปค่ะ,ราคาส่งราคาเท่าไหร่ค่ะ,ราคาส่งเท่าไรค่ะ,ราคาส่งเท่าไหร่,ราคาส่งเท่าไหร่ครับ,ราคาส่งเท่าไหร่ค่ะ ขายส่ง,สนใจซื้อราคาส่งมาขายจ้า,สนใจราคาส่งค่ะ,สนใจสินค้าราคาส่งค่ะ,สนใจเรทราคาส่งค่ะ,อบถามราคาส่งหน่อยจ้า,สอบถามราคาส่งจ้า,สอบถามเรทราคาส่งค่ะ สำหรับรับมาขายค่ะ,สินค้าขายราคาส่งยังไงคะ,อยากสอบถามว่าถ้าเราจะรับไปขาย ราคาส่งอย่างไรค่ะ,แล้วมีราคาส่งมั้ยค่ะ,ขอรายละเอียด ราคาส่งคะ,ถ้าราคาขายส่งต้องสั่งกี่ชุดอ่ะคะ,ราคาส่งเท่าไหร่ค่ะ ขายส่ง,สอบถามรายละเอียดขายส่งค่ะ,ขายส่งมีราคาแบบไหนบ้างคะ,สนใจขายส่ง ส่งยังงัยคะ,ราคาขายส่งคิดยังไงคะ,สอบถามรายละเอียดขายส่งค่ะ,กำลังหาร้านขายส่ง,ขายส่งอย่างเดียวใช่ไหมค่ะ,ขายส่งมีราคาแบบไหนบ้างคะ,ราคาขายส่งชุดละเท่าไหร่,ราคาส่งเท่าไหร่ค่ะ ขายส่ง,สนใจซื้อแบบขายส่งค่ะ มีเรทเท่าไหร่บ้างจ้า,includes(เรท&&ราคา&&ส่ง),includes(ราคา&&ส่ง),includes(เรท&&ขายส่ง),includes(สนใจ&&ขายส่ง),includes(ซื้อ&&ขายส่ง),includes(ราคาส่ง),includes(ขอเรท&&ส่ง),includes(รับ&&ขายส่ง),includes(เรท&&ราคา&&ส่ง),includes(ขายส่ง&&ไหม),includes(ขายส่ง&&มั้ย),includes(รายละเอียด&&ขายส่ง),includes(เรท&&ราคา&&ส่ง),includes(สอบถาม&&ขายส่ง),includes(สอบถาม&&เรทส่ง),exacts(ราคาส่ง)'
      },
      {
        name: 'Product warranty/Product replacement/Product claim',
        desc: '',
        icon: '',
        iconText: '💯',
        recommended: false,
        intentName: 'Template_การรับประกันสินค้า',
        val: 'การรับประกันควรทำอย่างไร,รับประกันกี่ปีคับ,มีใบรับประกันให้ด้วยใช่ไหมค่ะ,มีรับประกันสินค้ามั๊ย,มีรับประกันไหมครับ,มีรับประกันไหมค่ะ,รับประกันกี่ปีครับ,รับประกันสินค้าไหมคะ,รับประกันหรือป่าวครับ,รับประกันไหม,สินค้ามีรับประกันใช่มั๊ย,สินค้ารับประกันไหมครับ,ใบรับประกันจะกรอกยังไงคับ,ตัวนี้มีการรับประกันมั้ยครับ,ตัวนี้มีประกันไหมคะ,มีปัญหาติดต่อประกันที่ไหนครับ,มีรับประกันกี่ปีครับ,มีรับประกันมัยค่ะ,มีรับประกันมั้ยค่ะ,มีเงื่อนในการรับประกันไหมคับ,รับประกัน กี่ปีคะ,รับประกันกี่ปีคับ,รับประกันกี่ปีค่ะ ?,รับประกันคุณภาพสินค้ามั้ยครับ,รับประกันด้วยหรอคับ,รับประกันมั้ยครับ,รับประกันยังไงคะ,รุ่นนี้มีประกันมั้ยคะ,สินค้ามีประกันกี่ปีครับ,สินค้ามีประกันมั้ยคะ,สินค้ารับประกันนานเท่าไหร่คับ,แล้วประกันสินค้า,สินค้ารับประกัน กี่ปีครับ,รับประกันรับประกัน1ปี?,รับประกันสินค้าด้วยไหมคะ,สินค้ารับประกันไหม,รับประกันเท่าไหร่ครับ,รับประกันเครื่องไหมและกี่ปีค่ะ,ใบรับประกันมีมั้ยครับ,มีรับประกันด้วยมั้ยค่ะ,มีรับประกันตังเครื่องไหมคะ, มีรับประกันใช่มั่ยครับ,มีรับประกันใช้ใหมคับ,รับประกันสินค้าหรือป่าวครับ,รับประกันยังไงครับ,ประกันความเสียหายยังคับ,รับประกันยังไงคับ,รับประกันสินค้าไม่,รับประกันหรือเปล่าครับ,รับประกันเครื่องมั้ยค่ะ,รับประกันไมค่ะ,สินค้ารับประกันรึเปล่าคะ,สินค้ารับประกันนาน??,รับประกันกี่เดือนครับ,รับประกันยังไง,รับประกันกี่ปีคับ,รับประกันกี่ปีคะ,includes(การรับประกัน),includes(ประกันสินค้า),includes(รับประกัน),includes(ประกัน&&เท่าไหร่),includes(ประกัน&&เดือน),includes(ประกัน&&ปี),includes(ประกัน&&สินค้า),includes(ใบรับประกัน),includes(ประกัน&&นาน&&แค่ไหน),includes(รับประกัน&&ยังไง),includes(รับประกัน&&อย่างไร),includes(สินค้า&&มี&&ประกัน),includes(ประกัน&&ของ&&สินค้า),includes(รับประกัน&&มั้ย),includes(รับประกัน&&ไหม)'
      },
      {
        name: 'Received the product',
        desc: '',
        icon: '',
        iconText: '💞',
        recommended: false,
        intentName: 'Template_ได้รับสินค้า',
        val: 'ได้รับของเรียบร้อยแล้วค่ะ,ได้รับสินค้าแล้วนะคะ,ได้รับของแล้ว ชุดสวยมากคะ ไว้อุดหนุนไหม่นะคะ,ได้รับของแล้วคร้า,ได้รับของแล้วคะ,ได้รับของแล้วค่ะ,ได้รับของแล้วค่ะสวยถูกใจเลยค่ะ,ได้รับของแล้วค่า,ได้รับของแล้วนะ,ด้รับของแล้วนะคะของน่ารักมาก,ได้รับของแล้วนะคะ,ได้รับของแล้วนะคะส่งไวมากคะ,ได้รับแล้วนะค่ะ,ได้รับแล้วนะคะสวยมากค่ะตรงปกด้วย,ได้รับสินค้าแล้วนะค่ะ,ได้รับสินค้าแล้วค่ะ,ได้รับของเรียบร้อยค่ะ,ได้รับของแล้วค่ะ ขอบคุนนะคะ,ได้รับของแล้วนะคะ,ได้รับของแล้วค่ะ,ได้รับสินค้าแล้วค่ะ,ได้รับสินค้าแล้วค่ะสวยค่ะ,ได้รับสินค้าแล้วนะคะ ตรงปกทุกชุดค่ะ,ได้รับแล้ว,ได้รับแล้วนะคะ,ได้รับของแล้วนะคะเนื้อผ้าดีมากสวยมากค่ะ,ได้รับสินค้าแล้วน่ะคะ..สวยทุกตัวเลย,ชอบมากคะสวยมาก,ชอบมากค่ะ,includes(ได้รับ&&แล้ว),includes(รับ&&สินค้า&&แล้ว),includes(ถูกใจ&&มากเลย),includes(สินค้า&&ดีมาก),includes(ได้รับ&&ของ&&แล้ว),includes(ของ&&มาส่ง&&แล้ว),includes(ได้รับแล้ว)'
      },
      {
        name: 'Customer Informs phone number',
        desc: '',
        icon: '',
        iconText: '📞',
        recommended: false,
        intentName: 'Template_ลูกค้าแจ้งเบอร์โทร',
        val: '{phone}'
      },
      {
        name: 'Customer Informs the address',
        desc: '',
        icon: '',
        iconText: '🏠',
        recommended: false,
        intentName: 'Template_ลูกค้าแจ้งที่อยู่',
        val: '{address}'
      },
      {
        name: 'Customers Inform the province',
        desc: '',
        icon: '',
        iconText: '🌎',
        recommended: false,
        intentName: 'Template_ลูกค้าแจ้งจังหวัด',
        val: '{province}'
      }
    ],
    isUserOnline: null,
    pingLoginTimer: null,
    ttbChildPages: [],
    ttbCountAgentStatus: null,
    ttbCountAgentStatusTimer: null
  },
  getters,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/store.js